// extracted by mini-css-extract-plugin
export default {"footer":"tIHU0","content":"LXc1l ZdH1P","copyright":"T5zmw","container":"u2V3f ZdH1P","logo":"MAhcS","socials":"OEs5k","wideСopyright":"n8W9d"};